import { render, staticRenderFns } from "./custom-product-admin-tools.vue?vue&type=template&id=5601830c&scoped=true"
import script from "./custom-product-admin-tools.vue?vue&type=script&lang=js"
export * from "./custom-product-admin-tools.vue?vue&type=script&lang=js"
import style0 from "./custom-product-admin-tools.vue?vue&type=style&index=0&id=5601830c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5601830c",
  null
  
)

export default component.exports